var dev = false;
kimal.$preloader.addClass('loading');

if(!dev) {
  kimal.$window.on('load', function() {
    kimal.$preloader.addClass('loaded');

    if(kimal.$preloader.hasClass('loaded')) {
      kimal.$preloader.one('transitionend', function() {
        $('#preloader').fadeOut();
      });
    }
  });
} else {
  $('#preloader').remove();
}
